module.exports = __webpack_public_path__ + "static/media/CBN.179e965e.svg";